import { Dropdown } from "react-bootstrap";
import React from "react";
import { essenceClass } from "../../../essense";
import Blocker from "../../Misc/Blocker";

export default class ManualAddButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }
  onOpen = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ show: true });
  };
  onFinish = (e) => {
    this.setState({ show: false });
    if (this.props.onFinish) {
      this.props.onFinish(e);
    }
  };

  render() {
    return (
      <>
        <Dropdown>
          <Dropdown.Toggle as={DropdownToggle} id="dropdown-actions">
            <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <ActionsList
              essence={this.props.essence}
              key={this.props.id}
              id={this.props.id}
              label={this.props.label}
              onFinish={this.onFinish}
              structure={this.props.structure}
              disallow={this.props.disallow || []}
            />
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }
}

class ActionsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typeList: [],
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({ pending: true });

    let essence = new essenceClass("manual");
    let typeListResult = await essence.getTypeList();
    let typeList = {};
    typeListResult.forEach((type) => {
      typeList[type.classcode] = type.name;
    });

    this.setState({ pending: false, typeList });
  };

  render() {
    const structure = this.props.structure || "all";
    return (
      <>
        <Blocker on={this.state.pending}>
          {this.state.typeList.length === 0 ? (
            <div className="p-4">
              <span className="text-center text-muted font-italic">
                Нет доступных типов документации
              </span>
            </div>
          ) : null}
          {Object.keys(this.state.typeList).length > 0 ? (
            <div>
              {Object.keys(this.state.typeList).map((classcode) => {
                if (this.props.disallow.includes(classcode)) return null;
                return (
                  <a
                    className="btn w-100 text-hover-primary"
                    key={classcode}
                    href={`/manual/${structure}/${classcode}/add/`}
                  >
                    {this.state.typeList[classcode]}
                  </a>
                );
              })}
            </div>
          ) : null}
        </Blocker>
      </>
    );
  }
}

const DropdownToggle = React.forwardRef(({ children, onClick }, ref) => (
  <span
    ref={ref}
    title="Добавить"
    className="btn btn-light mr-2 text-hover-primary"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </span>
));
